// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media(max-width:1199px){
	.tax-plus-btn{
		margin-bottom: 150px;
	}
	#invoice-main .tax-plus-btn {
		bottom: 0%;
		right: 0%;
	}
}
@media(max-width:500px){
	.gol3{
		width: 56px;
		height: 56px;
		top: 14px;
	}
	.chart-container {
		width: 100%;
		height: auto;
	}
}
@media(max-width:400px){
	.slider-img img{
		width: 100%;
	}
	.new-invoice-modal{
		width: auto;
	}
	.navigation {
		max-width: 600px;
	}
}
@media(max-width:320px){
	.icons_main {
		column-gap: 16px;
	}
	.send-money-contact-tab{
		column-gap: 12px;
	}
	.icons_main a {
		padding: 8px;
	}
	.mt-32 {
		margin-top: 26px;
	}
	.verify-number-img img{
		width: 100%;
	}
	.pay-bill-sec {
		grid-template-columns: repeat(3, 1fr);
	}
	.about-us-icon-wrapper {
		grid-template-columns: repeat(2, 1fr);
	}
	.payfast-txt{
		font-size: 50px;
	}
	.payfast-img_main{
		width: 100px;
		height: 100px;
	}
	.payfast-img_main img{
		width: 100%;
	}
	.lets_you_in_box{
		padding: 16px;
	}
	#sign-in-main{
		margin-bottom: 180px;
	}
	#let-you-main{
		margin-bottom: 130px;
	}
	#bank-and-card-main .bank-card{
		display: grid;
	}
	#bank-and-card-main .transfer-first{
		column-gap: 12px;
	}
	.transfer-first{
		padding: 16px 0;
	}
	.search-text{
		font-size: 13px;
	}
	.custom-tab-invoice button{
		font-size: 14px;
		padding: 10px;
	}
	.order-txt1{
		font-size: 12px;
		line-height: 16px;
	}
	.social-media-content {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
	}
	.split7-screen-content-top img{
		width: 100%;
	}
	.middle{
		width: 190px;
		height: 190px;
	}
	.concentric-circles{
		width: 250px;
		height: 250px;
	}
	.gol3 {
		width: 45px;
		height: 45px;
		top: 25px;
	}
	.home-top-content{
		column-gap: 12px;
		margin-top: 16px;
	}
	.homepage-first{
		padding: 8px 0;
	}
	.contact-icon{
		width: 60px;
		height: 60px;
	}
	.contact-icon img{
		width: 40px;
	}
	.delete-account-trapping {
		margin-top: 20px;
	}
	.friend-name{
		font-size: 15px;
	}
	#notification-setting .notification-option-wrapper{
		column-gap: 8px;
	}
	#ui-datepicker-div{
		padding: 8px;
		margin: 10px 12px;
	}
	.contact-searchbar{
		padding: 12px !important;
	}
	.slider-txt {
		margin-top: 30px;
	}
	.slider-txt h2{
		font-size: 28px;
	}
	.scan1{
		width: 280px;
		height: 280px;
	}
	.scan1 .fingerprint1{
		width: 250px;
		height: 250px;
	}
}
@media(max-width:280px){
	.payfast-txt{
		font-size: 54px;
		line-height: 54px;
	}
	.mt-32 {
		margin-top: 26px;
	}
	.slider-txt h2{
		font-size: 24px;
		line-height: 36px;
	}
	.form-sign-in-password-btn a{
		padding: 12px 0;
	}
	.payfast-img_main{
		width: 100px;
		height: 100px;
	}
	.payfast-img_main img{
		width: 100%;
	}
	#mobile_code {
		margin-left: 6px;
		padding-left: 40px !important;
	}
	.iti__arrow:before {
		margin-left: 0 !important;
	}
	.otp-section input{
		width: 50px;
		height: 50px;
	}
}`, "",{"version":3,"sources":["webpack://./src/assets/css/media-query.css"],"names":[],"mappings":"AAAA;CACC;EACC,oBAAoB;CACrB;CACA;EACC,UAAU;EACV,SAAS;CACV;AACD;AACA;CACC;EACC,WAAW;EACX,YAAY;EACZ,SAAS;CACV;CACA;EACC,WAAW;EACX,YAAY;CACb;AACD;AACA;CACC;EACC,WAAW;CACZ;CACA;EACC,WAAW;CACZ;CACA;EACC,gBAAgB;CACjB;AACD;AACA;CACC;EACC,gBAAgB;CACjB;CACA;EACC,gBAAgB;CACjB;CACA;EACC,YAAY;CACb;CACA;EACC,gBAAgB;CACjB;CACA;EACC,WAAW;CACZ;CACA;EACC,qCAAqC;CACtC;CACA;EACC,qCAAqC;CACtC;CACA;EACC,eAAe;CAChB;CACA;EACC,YAAY;EACZ,aAAa;CACd;CACA;EACC,WAAW;CACZ;CACA;EACC,aAAa;CACd;CACA;EACC,oBAAoB;CACrB;CACA;EACC,oBAAoB;CACrB;CACA;EACC,aAAa;CACd;CACA;EACC,gBAAgB;CACjB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;EACf,aAAa;CACd;CACA;EACC,eAAe;EACf,iBAAiB;CAClB;CACA;EACC,aAAa;EACb,qCAAqC;CACtC;CACA;EACC,WAAW;CACZ;CACA;EACC,YAAY;EACZ,aAAa;CACd;CACA;EACC,YAAY;EACZ,aAAa;CACd;CACA;EACC,WAAW;EACX,YAAY;EACZ,SAAS;CACV;CACA;EACC,gBAAgB;EAChB,gBAAgB;CACjB;CACA;EACC,cAAc;CACf;CACA;EACC,WAAW;EACX,YAAY;CACb;CACA;EACC,WAAW;CACZ;CACA;EACC,gBAAgB;CACjB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,YAAY;EACZ,iBAAiB;CAClB;CACA;EACC,wBAAwB;CACzB;CACA;EACC,gBAAgB;CACjB;CACA;EACC,eAAe;CAChB;CACA;EACC,YAAY;EACZ,aAAa;CACd;CACA;EACC,YAAY;EACZ,aAAa;CACd;AACD;AACA;CACC;EACC,eAAe;EACf,iBAAiB;CAClB;CACA;EACC,gBAAgB;CACjB;CACA;EACC,eAAe;EACf,iBAAiB;CAClB;CACA;EACC,eAAe;CAChB;CACA;EACC,YAAY;EACZ,aAAa;CACd;CACA;EACC,WAAW;CACZ;CACA;EACC,gBAAgB;EAChB,6BAA6B;CAC9B;CACA;EACC,yBAAyB;CAC1B;CACA;EACC,WAAW;EACX,YAAY;CACb;AACD","sourcesContent":["@media(max-width:1199px){\n\t.tax-plus-btn{\n\t\tmargin-bottom: 150px;\n\t}\n\t#invoice-main .tax-plus-btn {\n\t\tbottom: 0%;\n\t\tright: 0%;\n\t}\n}\n@media(max-width:500px){\n\t.gol3{\n\t\twidth: 56px;\n\t\theight: 56px;\n\t\ttop: 14px;\n\t}\n\t.chart-container {\n\t\twidth: 100%;\n\t\theight: auto;\n\t}\n}\n@media(max-width:400px){\n\t.slider-img img{\n\t\twidth: 100%;\n\t}\n\t.new-invoice-modal{\n\t\twidth: auto;\n\t}\n\t.navigation {\n\t\tmax-width: 600px;\n\t}\n}\n@media(max-width:320px){\n\t.icons_main {\n\t\tcolumn-gap: 16px;\n\t}\n\t.send-money-contact-tab{\n\t\tcolumn-gap: 12px;\n\t}\n\t.icons_main a {\n\t\tpadding: 8px;\n\t}\n\t.mt-32 {\n\t\tmargin-top: 26px;\n\t}\n\t.verify-number-img img{\n\t\twidth: 100%;\n\t}\n\t.pay-bill-sec {\n\t\tgrid-template-columns: repeat(3, 1fr);\n\t}\n\t.about-us-icon-wrapper {\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t}\n\t.payfast-txt{\n\t\tfont-size: 50px;\n\t}\n\t.payfast-img_main{\n\t\twidth: 100px;\n\t\theight: 100px;\n\t}\n\t.payfast-img_main img{\n\t\twidth: 100%;\n\t}\n\t.lets_you_in_box{\n\t\tpadding: 16px;\n\t}\n\t#sign-in-main{\n\t\tmargin-bottom: 180px;\n\t}\n\t#let-you-main{\n\t\tmargin-bottom: 130px;\n\t}\n\t#bank-and-card-main .bank-card{\n\t\tdisplay: grid;\n\t}\n\t#bank-and-card-main .transfer-first{\n\t\tcolumn-gap: 12px;\n\t}\n\t.transfer-first{\n\t\tpadding: 16px 0;\n\t}\n\t.search-text{\n\t\tfont-size: 13px;\n\t}\n\t.custom-tab-invoice button{\n\t\tfont-size: 14px;\n\t\tpadding: 10px;\n\t}\n\t.order-txt1{\n\t\tfont-size: 12px;\n\t\tline-height: 16px;\n\t}\n\t.social-media-content {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(3, 1fr);\n\t}\n\t.split7-screen-content-top img{\n\t\twidth: 100%;\n\t}\n\t.middle{\n\t\twidth: 190px;\n\t\theight: 190px;\n\t}\n\t.concentric-circles{\n\t\twidth: 250px;\n\t\theight: 250px;\n\t}\n\t.gol3 {\n\t\twidth: 45px;\n\t\theight: 45px;\n\t\ttop: 25px;\n\t}\n\t.home-top-content{\n\t\tcolumn-gap: 12px;\n\t\tmargin-top: 16px;\n\t}\n\t.homepage-first{\n\t\tpadding: 8px 0;\n\t}\n\t.contact-icon{\n\t\twidth: 60px;\n\t\theight: 60px;\n\t}\n\t.contact-icon img{\n\t\twidth: 40px;\n\t}\n\t.delete-account-trapping {\n\t\tmargin-top: 20px;\n\t}\n\t.friend-name{\n\t\tfont-size: 15px;\n\t}\n\t#notification-setting .notification-option-wrapper{\n\t\tcolumn-gap: 8px;\n\t}\n\t#ui-datepicker-div{\n\t\tpadding: 8px;\n\t\tmargin: 10px 12px;\n\t}\n\t.contact-searchbar{\n\t\tpadding: 12px !important;\n\t}\n\t.slider-txt {\n\t\tmargin-top: 30px;\n\t}\n\t.slider-txt h2{\n\t\tfont-size: 28px;\n\t}\n\t.scan1{\n\t\twidth: 280px;\n\t\theight: 280px;\n\t}\n\t.scan1 .fingerprint1{\n\t\twidth: 250px;\n\t\theight: 250px;\n\t}\n}\n@media(max-width:280px){\n\t.payfast-txt{\n\t\tfont-size: 54px;\n\t\tline-height: 54px;\n\t}\n\t.mt-32 {\n\t\tmargin-top: 26px;\n\t}\n\t.slider-txt h2{\n\t\tfont-size: 24px;\n\t\tline-height: 36px;\n\t}\n\t.form-sign-in-password-btn a{\n\t\tpadding: 12px 0;\n\t}\n\t.payfast-img_main{\n\t\twidth: 100px;\n\t\theight: 100px;\n\t}\n\t.payfast-img_main img{\n\t\twidth: 100%;\n\t}\n\t#mobile_code {\n\t\tmargin-left: 6px;\n\t\tpadding-left: 40px !important;\n\t}\n\t.iti__arrow:before {\n\t\tmargin-left: 0 !important;\n\t}\n\t.otp-section input{\n\t\twidth: 50px;\n\t\theight: 50px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
